import './register.scss';
import React from 'react';
import { Row, Col, Button, Alert } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { Translate, translate, Storage } from 'react-jhipster';
import { RouteComponentProps, Redirect } from 'react-router-dom';
import MessageModal from '../../../shared/message/message-modal';
import {
  handleRegisterSIM,
  handleRegisterToken,
  handleAddToken,
  handleAddSIM,
  reset,
  handleRegisterSmartCA,
  handleAddSmartCA
} from './register.reducer';
import { IRootState } from 'app/shared/reducers';
import { connect } from 'react-redux';
import { IND, ENP, ORG, SUCCESS, LINK_TERM_OF_USE } from 'app/config/constants';
import ShowMessageModal from './showMessage-modal';
import { generateCaptcha } from '../password-reset/password-reset.reducer';
import { login } from 'app/shared/util/utilities';
import moment from 'moment';
import RegisterBottom from './registerBottom';

export interface IRegisterInfoProps extends StateProps, DispatchProps, RouteComponentProps<{}> {}

export interface IRegisterInfoState {
  visible: boolean;
  color: string;
  message: string;
  certInfo: any;
  redirectLogin: boolean;
  showMessage: boolean;
  userType: string;
  isMobile: boolean;
  disableButtonReg: boolean;
  showMessageAccountExist: boolean;
  captcha: string;
  identity: string;
  unitCode: string;
  nameCA: string;
  captchaValue: string;
}
export class RegisterInfo extends React.Component<IRegisterInfoProps, IRegisterInfoState> {
  state: IRegisterInfoState = {
    visible: false,
    color: 'danger',
    message: '',
    certInfo: {},
    redirectLogin: false,
    showMessage: false,
    userType: '',
    isMobile: false,
    disableButtonReg: false,
    showMessageAccountExist: false,
    captcha: '',
    identity: '',
    nameCA: '',
    captchaValue: '',
    unitCode: ''
  };

  componentDidMount() {
    this.props.generateCaptcha();
    let certInfo = Storage.session.get('certInfo');
    const userType = Storage.session.get('userType');
    window['is_mobile']();
    this.setState({
      certInfo: certInfo,
      userType: userType,
      isMobile: window['isMobile']
    });
  }

  componentWillReceiveProps(nextProps) {
    // register smart ca
    if (this.props.responseRegSmartCA !== nextProps.responseRegSmartCA) {
      const { responseRegSmartCA } = nextProps;
      if (responseRegSmartCA && responseRegSmartCA.status === 'SUCCESS') {
        this.setState({
          showMessage: true,
          message: this.state.showMessageAccountExist
            ? 'Chúc mừng bạn đã thêm phương thức xác thực thành công.'
            : 'Chúc mừng bạn đã đăng ký thành công.',
          disableButtonReg: false
        });
        let timerId = setTimeout(() => {
          this.setState({
            showMessage: false,
            redirectLogin: true,
            showMessageAccountExist: false
          });
        }, 3000);
      } else if (responseRegSmartCA && responseRegSmartCA.status === 'KEY_NOT_CORRECT') {
        this.setState({
          disableButtonReg: false,
          showMessageAccountExist: false,
          visible: true,
          color: 'danger',
          message: responseRegSmartCA.message
        });
      } else if (responseRegSmartCA && responseRegSmartCA.status === 'ACCOUNT_EXIST') {
        this.setState({
          showMessageAccountExist: true,
          disableButtonReg: false
        });
      } else {
        this.setState({
          disableButtonReg: false,
          showMessageAccountExist: false,
          visible: true,
          color: 'danger',
          message: responseRegSmartCA.message
        });
      }
    }

    if (this.props.resultReg !== nextProps.resultReg) {
      const { resultReg } = nextProps;
      if (resultReg && resultReg.status === 'SUCCESS') {
        this.removeAllStorage();
        this.setState({
          redirectLogin: true
          // message: this.state.showMessageAccountExist
          //   ? 'Chúc mừng bạn đã thêm phương thức xác thực thành công.'
          //   : 'Chúc mừng bạn đã đăng ký thành công.',
          // disableButtonReg: false
        });
        // let timerId = setTimeout(() => {
        //   this.setState({
        //     showMessage: false,
        //     redirectLogin: true,
        //     showMessageAccountExist: false
        //   });
        // }, 3000);
      } else if (resultReg && resultReg.status === 'ACCOUNT_EXIST') {
        this.setState({
          showMessageAccountExist: true,
          disableButtonReg: false
        });
      } else if (resultReg && resultReg.status === 'KEY_NOT_CORRECT') {
        this.setState({
          captcha: '',
          disableButtonReg: false,
          showMessageAccountExist: false,
          visible: true,
          color: 'danger',
          message: resultReg.message && resultReg.message !== 'ERROR' ? resultReg.message : translate('register.messages.error.fail')
        });
      } else if (resultReg && resultReg.status) {
        this.setState({
          disableButtonReg: false,
          showMessageAccountExist: false,
          visible: true,
          color: 'danger',
          message: resultReg.message && resultReg.message !== 'ERROR' ? resultReg.message : translate('register.messages.error.fail')
        });
      }
    }

    if (nextProps.regTokenFailure) {
      this.setState({
        disableButtonReg: false,
        showMessageAccountExist: false,
        visible: true,
        color: 'danger',
        message:
          this.state.userType === IND
            ? 'Không tìm thấy thông tin cá nhân tại cơ sở dữ liệu của Ban Cơ yếu, vui lòng liên hệ với đầu mối của Ban Cơ yếu để kiểm tra!'
            : this.state.userType === ORG
            ? 'Không tìm thấy thông tin tổ chức tại cơ sở dữ liệu của Ban Cơ yếu, vui lòng liên hệ với đầu mối của Ban Cơ yếu để kiểm tra!'
            : 'Bạn đang dùng chứng thư số của Ban Cơ yếu vui lòng chọn chứng thư đúng để đăng ký doanh nghiệp!'
      });
    }

    if (this.props.responseCap !== nextProps.responseCap) {
      const { responseCap } = nextProps;
      if (responseCap.status === SUCCESS) {
        this.setState({
          captcha: responseCap.message
        });
      }
    } else {
      this.props.generateCaptcha();
    }
  }

  componentWillUnmount() {
    this.props.reset();
  }

  handleValidSubmit = (event, values) => {
    const { certInfo } = this.state;
    const type = Storage.session.get('type');
    const userType = Storage.session.get('userType');
    //const phone = Storage.session.get('phone');
    if (type && type === 'Token') {
      const signed = Storage.session.get('singed');
      const otp = Storage.session.get('totp');
      this.state.showMessageAccountExist
        ? this.props.handleAddToken(signed, certInfo.base64, otp, userType, '', this.props.resultReg.message)
        : this.props.handleRegisterToken(
            signed,
            certInfo.base64,
            otp,
            userType,
            values.email,
            values.captcha,
            '',
            this.state.identity,
            this.state.unitCode
          );
    } else if (type && type === 'Sim') {
      let provider = '';
      if (this.props.location.state) {
        provider = this.props.location.state.provider;
      }
      this.state.showMessageAccountExist
        ? this.props.handleAddSIM(certInfo.cert, userType, '', certInfo.phone, this.props.resultReg.message, provider)
        : this.props.handleRegisterSIM(certInfo.cert, userType, values.email, certInfo.phone, values.captcha, provider);
    } else if (type && type === 'SmartCA') {
      var dict = {};
      dict['IssuerDN'] = this.state.certInfo.issuerCN;
      dict['sub'] = this.state.certInfo.sub;
      dict['validFrom'] = moment(this.state.certInfo.notBefore, 'YYYYMMDDhhmmssZ').format('DD/MM/YYYY');
      dict['validTo'] = moment(this.state.certInfo.notAfter, 'YYYYMMDDhhmmssZ').format('DD/MM/YYYY');
      dict['serial'] = this.state.certInfo.serialNumber;
      dict['cert'] = this.state.certInfo.cert;
      dict['email'] = this.state.showMessageAccountExist ? '' : values.email;
      dict['fullName'] = this.state.certInfo.subjectCN;
      dict['identity'] = this.state.certInfo.identity;
      dict['tax'] = this.state.certInfo.tax;
      dict['userType'] = userType;
      dict['captcha'] = this.state.showMessageAccountExist ? '' : values.captcha;
      dict['id'] = this.props.responseRegSmartCA && this.state.showMessageAccountExist ? this.props.responseRegSmartCA.message : '';
      this.state.showMessageAccountExist ? this.props.handleAddSmartCA(dict) : this.props.handleRegisterSmartCA(dict);
    }
    this.setState({ disableButtonReg: true });
  };

  resetForm = () => {
    this.setState({
      identity: '',
      nameCA: '',
      captchaValue: '',
      unitCode: ''
    });
  };

  removeAllStorage = () => {
    Storage.session.remove('type');
    Storage.session.remove('userType');
    //Storage.session.remove('phone');
    Storage.session.remove('singed');
    Storage.session.remove('totp');
    Storage.session.remove('certInfo');
    Storage.session.remove('codeSmartCA');
  };

  onDismiss = () => {
    this.setState({ visible: false });
  };

  handleClose = () => {
    this.setState({
      showMessageAccountExist: false
    });
  };

  invokeResetCaptcha = () => {
    this.props.generateCaptcha();
  };

  handleChange = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleChangeCaptcha = e => {
    const { name, value } = e.target;
    this.setState({ captchaValue: value });
  };

  render() {
    if (this.state.redirectLogin) {
      this.removeAllStorage();
      // login(this.props.config);
      return (
        <Redirect
          push
          to={{
            pathname: `/success`,
            state: {
              config: this.props.config
            }
          }}
        />
      );
    }

    let name = 'Họ tên';
    if (this.state.userType && this.state.userType === ENP) {
      name = 'Tên doanh nghiệp';
    }
    if (this.state.userType && this.state.userType === ORG) {
      name = 'Tên tổ chức';
    }

    //const totp = this.props.location.state && this.props.location.state.totp ? this.props.location.state.totp.message : '';
    //const userType = this.props.location.state ? this.props.location.state.userType : '';
    const { certInfo } = this.state;
    const type = Storage.session.get('type');
    return (
      <div className="box-registerinfo">
        <MessageModal type={SUCCESS} showModal={this.state.showMessage} message={this.state.message} />
        <ShowMessageModal
          showModal={this.state.showMessageAccountExist}
          message="Tài khoản đã tồn tại. Bạn có muốn thêm phương thức không?"
          handleClose={this.handleClose}
          handleSubmit={this.handleValidSubmit}
        />
        <Row className="justify-content-center">
          <Col md="12">
            <h2 className="text-center font-weight-bold" id="register-title">
              <Translate contentKey="register.title">Registration</Translate>
            </h2>
            <p className="text-center txtContent">
              <Translate contentKey="register.txtContent" />
            </p>
            <Alert id="myAlert" color={this.state.color} isOpen={this.state.visible} toggle={this.onDismiss}>
              {this.state.message}
            </Alert>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md="12">
            <AvForm id="register-form" onValidSubmit={this.handleValidSubmit}>
              {/* <input type="hidden" id="totp" name="totp" value={totp} />
              <input type="hidden" id="userType" name="userType" value={userType} />
              <input type="hidden" id="cert" name="cert" value={certInfo ? certInfo.cert : ''} /> */}
              {type && type === 'Sim' ? (
                this.state.userType && this.state.userType === ENP ? (
                  <AvField name="identity" label={translate('global.form.tax.label')} value={certInfo ? certInfo.uid : ''} readOnly />
                ) : (
                  <AvField name="identity" label={translate('global.form.identity.label')} value={certInfo ? certInfo.uid : ''} readOnly />
                )
              ) : null}
              <AvField name="fullName" label={name} value={certInfo ? certInfo.subjectCN : ''} readOnly />

              {type && type === 'SmartCA' ? (
                <AvField
                  name="fromDate"
                  label={translate('global.form.fromDate.label')}
                  value={certInfo ? moment(certInfo.notBefore, 'YYYYMMDDhhmmssZ').format('DD/MM/YYYY') : ''}
                  readOnly
                />
              ) : (
                <AvField
                  name="fromDate"
                  label={translate('global.form.fromDate.label')}
                  value={certInfo ? certInfo.notBefore : ''}
                  readOnly
                />
              )}

              {type && type === 'SmartCA' ? (
                <AvField
                  name="toDate"
                  label={translate('global.form.toDate.label')}
                  value={certInfo ? moment(certInfo.notAfter, 'YYYYMMDDhhmmssZ').format('DD/MM/YYYY') : ''}
                  readOnly
                />
              ) : (
                <AvField name="toDate" label={translate('global.form.toDate.label')} value={certInfo ? certInfo.notAfter : ''} readOnly />
              )}

              <AvField name="nameCA" label={translate('global.form.nameCA.label')} value={this.state.nameCA} onChange={this.handleChange} />
              {/* <div className="form-group">
                <label htmlFor="email">{translate('global.form.email.label')}</label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  aria-describedby="emailHelp"
                  placeholder={translate('global.form.email.placeholder')}
                />
              </div> */}
              <AvField
                name="email"
                label={translate('global.form.email.require')}
                placeholder={translate('global.form.email.placeholder')}
                type="email"
                value={certInfo ? certInfo.Email : ''}
                readOnly
                // validate={{
                //   required: {
                //     value: true,
                //     errorMessage: translate('register.messages.validate.email.required')
                //   },
                //   email: { value: true, errorMessage: translate('register.messages.validate.email.pattern') }
                // }}
              />
              {this.state.userType === IND ? (
                <AvField
                  name="identity"
                  label={translate('global.form.cmt.label')}
                  placeholder={translate('global.form.cmt.placeholder')}
                  // autoFocus={!this.state.isMobile}
                  // type="number"
                  value={this.state.identity}
                  onChange={this.handleChange}
                  validate={{
                    required: { value: true, errorMessage: translate('register.messages.validate.cmt/cccd.required') },
                    pattern: {
                      value: '^([0-9]{9}|[0-9]{12})+$',
                      errorMessage: translate('register.messages.validate.cmt/cccd.pattern')
                    },
                    minLength: { value: 9, errorMessage: translate('register.messages.validate.cmt/cccd.minlength') },
                    maxLength: { value: 12, errorMessage: translate('register.messages.validate.cmt/cccd.minlength') }
                  }}
                />
              ) : (
                <AvField
                  name="unitCode"
                  label={
                    <span>
                      Mã tổ chức <strong> *</strong>
                    </span>
                  }
                  value={this.state.unitCode}
                  onChange={this.handleChange}
                  validate={{
                    required: { value: true, errorMessage: 'Bạn phải nhập mã tổ chức' },
                    maxLength: { value: 50, errorMessage: 'Mã tổ chức không được nhập quá 50 ký tự.' }
                  }}
                />
              )}

              {/*<AvField*/}
              {/*  name="unitname"*/}
              {/*  label={translate('global.form.unitname.require')}*/}
              {/*  type="select"*/}
              {/*  validate={{*/}
              {/*    required: { value: true, errorMessage: translate('register.messages.validate.unitname.required') }*/}
              {/*  }}*/}
              {/*>*/}
              {/*  {' '}*/}
              {/*  <option hidden value="" className="placeholder-select" style={{ color: '#C3C8D2' }}>*/}
              {/*    {translate('global.form.unitname.placeholder')}*/}
              {/*  </option>*/}
              {/*  <option>VNPT Certification Authority</option>*/}
              {/*  <option>2</option>*/}
              {/*  <option>3</option>*/}
              {/*  <option>4</option>*/}
              {/*</AvField>*/}

              <label>{translate('global.form.code.label')}</label>
              <Row style={{ flex: 1 }}>
                <Col style={{ flex: 0.6 }}>
                  <AvField
                    id="input-captcha"
                    name="captcha"
                    label=""
                    placeholder="Nhập mã xác thực"
                    type="text"
                    value={this.state.captchaValue}
                    onChange={this.handleChangeCaptcha}
                    validate={{
                      required: { value: true, errorMessage: 'Nhập mã xác thực' }
                    }}
                  />
                </Col>
                <Col style={{ flex: 0.3 }}>
                  <img style={{ height: '39px' }} src={`data:image/jpeg;base64,${this.state.captcha}`} alt="" />
                </Col>

                <Col style={{ flex: 0.1 }}>
                  <img className="" src={require('../../../images/header/refresh.svg')} onClick={this.invokeResetCaptcha} alt="" />
                </Col>
              </Row>
              <div className="li">
                Bằng cách nhấp vào Đăng ký, bạn đồng ý với{' '}
                <a className="link" href={LINK_TERM_OF_USE} target="_blank">
                  Điều khoản, Chính sách chia sẻ thông tin
                </a>{' '}
                của chúng tôi
              </div>
              <Button className="btn-register" style={{ marginTop: '20px' }} type="submit" disabled={this.state.disableButtonReg} block>
                <Translate contentKey="register.form.button">Register</Translate>
              </Button>
              <Button className="btn-register" style={{ marginTop: '20px' }} type="button" onClick={this.resetForm} block>
                Làm mới
              </Button>
              <div style={{ marginTop: '10px' }}>
                <RegisterBottom isInsurance={true} />
              </div>
            </AvForm>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  resultReg: storeState.register.resultRegSim,
  resultAdd: storeState.register.resultAdd,
  responseCap: storeState.passwordReset.responseCaptcha,
  config: storeState.applicationProfile.config,
  regTokenFailure: storeState.register.regTokenFailure,
  responseRegSmartCA: storeState.register.responseRegSmartCA
});

const mapDispatchToProps = {
  handleRegisterSIM,
  handleRegisterToken,
  handleAddToken,
  handleAddSIM,
  reset,
  generateCaptcha,
  handleRegisterSmartCA,
  handleAddSmartCA
};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterInfo);
